import CustomComponent from '../CustomComponent';

export class CompetitionProfileMemberCard extends CustomComponent {
	static key = 'lta-competition-profile-member-card';

	static get observedAttributes() {
		return ['data-member'];
	}

	constructor() {
		super();
		this.render();
	}

	parseMember() {
		const detailsCount = Number(this.getAttribute('data-details-count') || 0);
		const details = [];
		for (let i = 0; i < detailsCount; i++) {
			details.push({
				label: this.getAttribute(`data-detail-${i}-label`),
				value: this.getAttribute(`data-detail-${i}-value`),
				type: this.getAttribute(`data-detail-${i}-type`),
				order: Number(this.getAttribute(`data-detail-${i}-order`))
			});
		}
		return {
			id: this.getAttribute('data-member-id'),
			sfid: this.getAttribute('data-member-sfid'),
			firstName: this.getAttribute('data-member-firstname'),
			lastName: this.getAttribute('data-member-lastname'),
			status: this.getAttribute('data-member-status'),
			showEditDetailsButton: this.getAttribute('data-show-edit-details-button') === 'true',
			editDetailButtonInfo: {
				label: this.getAttribute('data-edit-button-label'),
				icon: this.getAttribute('data-edit-button-icon'),
				link: this.getAttribute('data-edit-button-link')
			},
			details
		};
	}

	getAge(dob) {
		if (!dob) return '';
		const birth = new Date(dob);
		const diff = Date.now() - birth.getTime();
		return Math.abs(new Date(diff).getUTCFullYear() - 1970);
	}

	/* ------------------------------------
	 * Event binding
	 * ---------------------------------- */
	getStatusBadge(member) {
		if (!member.status) return '';
		const status = member.status.toLowerCase();

		if (status === 'details completed') {
			return `
            <div class="p-household-member-success-page__status-badge lta-tag__wrapper u-body2"
                 style="background-color:#EFF8F0; color:#408627; white-space:nowrap;">
                <svg width="1em" height="1em" fill="currentColor">
                    <use href="/static/images/icons/lta-icons.svg#check-circle-2"></use>
                </svg>
                ${member.status}
            </div>`;
		}

		if (status === 'details missing') {
			return `
            <div class="p-household-member-success-page__status-badge lta-tag__wrapper u-body2"
                 style="background-color:#FFF9F6; color:#CA5009; white-space:nowrap;">
                <svg width="1em" height="1em" fill="currentColor">
                    <use href="/static/images/icons/lta-icons.svg#analog-clock"></use>
                </svg>
                ${member.status}
            </div>`;
		}
		return '';
	}

	getEditDetailsButton(member) {
		if (!member.showEditDetailsButton) return '';

		const label = member.editDetailButtonInfo?.label;
		const icon = member.editDetailButtonInfo?.icon;
		const link = member.editDetailButtonInfo?.link;

		if (!link) return '';

		return `
            <a href="${link}" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before">
                <svg 
                    class="lta-icon js-lta-text-input--btn-icon u-mr-1" 
                    width="1.5em" 
                    height="1.5em" 
                    style="color:;" fill="" 
                    alt="eye-fill" 
                    aria-hidden="true" 
                    currentcolor=""
                >
                    <use xlink:href="/static/images/icons/lta-icons.svg#${icon}"></use>
                </svg>
                ${label}
            </a>
	    `;
	}

	/* ------------------------------------
	 * Render
	 * ---------------------------------- */
	render() {
		const member = this.parseMember();

		const details = (member.details || []).sort((a, b) => a.order - b.order);

		const detailsHtml = details
			.map((d) => {
				let value = d.value;
				if (d.type === 'dateOfBirth') {
					value = this.getAge(d.value);
				}
				return `<div class="u-body2">${d.label}: ${value}</div>`;
			})
			.join('');

		const isMissing = member.status?.toLowerCase() === 'details missing';

		return `
		<div class="lta-household-member-card ${isMissing ? 'js-member-card-missing' : ''}">
			
			${
				isMissing
					? ` <div class="missing-details-text u-caption2 u-text-error u-mb-1 u-hidden">
				            Please provide the missing details
			            </div>`
					: ''
			}

			<div class="member-card-wrapper u-p-3 u-rounded u-body2 u-text-grey-dark u-border u-border-grey-light u-mb-3">
				<div class="u-flex u-flex-column u-align-start u-gap-1">
					<div class="u-flex u-justify-space-between u-align-center u-gap-1 u-w-100" style="word-break:break-word;">
						<div class="u-caption1">${member.firstName} ${member.lastName}</div>
					</div>

					<div>${detailsHtml}</div>

					${this.getStatusBadge(member)}

					${this.getEditDetailsButton(member)}
				</div>
			</div>
		</div>
	`;
	}
}

export default CompetitionProfileMemberCard;
